import BsModal from "./BsModal";
import BsLightbox from "./BsLightbox";

export default Vue => {
    Vue.component(BsModal.name, BsModal);
    Vue.component(BsLightbox.name, BsLightbox);
};
